module.exports = __webpack_public_path__ + "img/dep_dairy@2x.a301933b.png";